import { ReactiveController, ReactiveControllerHost } from 'lit';
import { isOnline } from './helpers';

/** A reactive controller that tracks online/offline status 
 * where navigator.onLine alone will not suffice for non reactive components that don't force a re-render
*/

export class OnlineStatusController implements ReactiveController {
  private host: ReactiveControllerHost;
  private _isOnline: boolean = isOnline();

  get isOnline(): boolean {
    return this._isOnline;
  }

  constructor(host: ReactiveControllerHost) {
    this.host = host;
    this.host.addController(this);
  }

  hostConnected() {

    window.addEventListener('online', this._handleNetworkChange);
    window.addEventListener('offline', this._handleNetworkChange);
  }

  hostDisconnected() {
    window.removeEventListener('online', this._handleNetworkChange);
    window.removeEventListener('offline', this._handleNetworkChange);
  }

  private _handleNetworkChange = () => {
    if (this._isOnline !== isOnline()) {
      this._isOnline = isOnline();
      this.host.requestUpdate();
    }
  };
}